import { Button, ClickEvent, Table, TableSelectionEvent } from "@mcleod/components";
import { TrailerList } from "./TrailerList";
import { AutogenLayoutTrailerToolPanel } from "./autogen/AutogenLayoutTrailerToolPanel";
import { ModelRow } from "@mcleod/core";
import { Seating, SeatingEquipmentType } from "./Seating";


export class TrailerToolPanel extends AutogenLayoutTrailerToolPanel {

    private table: Table;
    private tableSelectedPromise: Promise<void>;

    override onLoad() {
        this.addMountListener(() => this.initialize(this.owner));
    }

    private initialize(layout: TrailerList) {
        this.table = layout.tableTrailers;
        this.table?.addSelectionListener((event: TableSelectionEvent) => {
            this.tableSelectedPromise = this.tableOnSelect(event);
        });
    }

    private async tableOnSelect(event: TableSelectionEvent) {
        const modelRow = event.newRow?.data;
        await this.syncToolPanel(modelRow);
    }

    private getAllVisibleButtons(): Button[] {
        return this.panelButtons?.findComponentsByType(Button)?.filter(button => button.visible);
    }

    public async syncToolPanel(modelRow: ModelRow) {
        this.getAllVisibleButtons().forEach(button => {
            button.disabledTooltip = null;
            this.syncButtonState(button, modelRow);
        });
    }

    private syncButtonState(button: Button, modelRow: ModelRow) {
        let shouldEnable: boolean;
        if (button === this.buttonLocateTrailer) {
            shouldEnable = this.buttonLocateTrailerEnabled(modelRow);
        }
        button.enabled = shouldEnable;
    }

    private buttonLocateTrailerOnClick(event: ClickEvent) {
        const modelRow: ModelRow = this.table?.selectedRow?.data;
        const button = event.target as Button;

        button.busy = true;
        Seating.showSlideout({
            equipmentId: modelRow?.get("id", null),
            equipmentType: SeatingEquipmentType.TRAILER,
            forceMasterfileUpdate: true,
            doAfterSave: () => {
                this.table?.selectedRow?.updateDataFromComponents();
            }
        });
        button.busy = false;
    }

    private buttonLocateTrailerEnabled(modelRow: ModelRow): boolean {
        if (this.buttonLocateTrailer.visible === false) return false;
        if (modelRow == null) return true; // Slideout allows null equipment

        if (modelRow.getString("is_active") != "A") {
            this.buttonLocateTrailer.disabledTooltip = "Trailer's Service Status must be Active to locate.";
            return false;
        }
        if (modelRow.get("movement.status") === "P") {
            this.buttonLocateTrailer.disabledTooltip = "Cannot locate Trailer for In-Progress movements";
            return false;
        }
        return true;
    }

}
